import React from 'react';
import twMerge from 'utilities/src/twMerge';

interface Props {
  children: React.ReactNode;
  isDark: boolean;
  classes?: string;
}

export default function BackgroundWrapper({ children, classes, isDark }: Props) {
  return (
    <div
      className={twMerge(
        'transition-[background-color] duration-300',
        'bg-site-neutrals-25',
        {
          'bg-site-neutrals-900/80': isDark,
        },
        classes,
      )}
    >
      {children}
    </div>
  );
}
